import React from "react";
import { BrowserRouter as Router, useLocation, Routes, Route } from 'react-router-dom';

import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';

import LoginForm from "./Components/LoginForm";
import DashboardRoutes from "./Components/DashboardRoutes";
import InviteRegistration from "./Pages/Public/InviteRegistration";
import ForgotPassword from "./Pages/Public/ForgotPassword";
import ResetPassword from "./Pages/Public/ResetPassword";
import SetPassword from "./Pages/Public/SetPassword";
import { AuthProvider, useAuth } from "./Context/AuthContext";
import { FormProvider } from "./Context/FormContext";
import { HeaderVisibilityProvider, useHeaderVisibility } from "./Context/HeaderVisibilityContext";
import Navbar from "./Components/Navbar";
import FeedbackButton from "./Components/FeedbackButton";
import { FeedbackProvider } from "./Context/FeedbackContext";

// Componente principal
function AppContent() {
    const { user, isLoading, logout } = useAuth();
    const { isHeaderVisible } = useHeaderVisibility();
    const location = useLocation();

    // Check if we're on user home page
    const isUserHome = user?.role === 'USER' && location.pathname === '/user/dashboard';

    // Check if we're on a public route
    const isPublicRoute = location.pathname.startsWith('/join/') ||
        location.pathname === '/forgot-password' ||
        location.pathname === '/reset-password' ||
        location.pathname === '/set-password';

    // Public routes - render without authentication check
    if (isPublicRoute) {
        return (
            <Routes>
                <Route path="/join/:ownerId" element={<InviteRegistration />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/set-password" element={<SetPassword />} />
            </Routes>
        );
    }

    // Mientras se verifica la autenticación, mostramos un indicador de carga
    if (isLoading) {
        return (
            <div className="loader-container">
                <div className="spinner-border spinner-primary" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </div>
            </div>
        );
    }

    // Si el usuario no está autenticado, mostramos solo el formulario de login
    if (!user?.isAuthenticated) {
        return (
            <div className="auth-container">
                <div className="login-form-container">
                    <LoginForm />
                </div>
            </div>
        );
    }

    // Si el usuario está autenticado, mostramos la aplicación completa según su rol
    return (
        <div className="app-container">
            <Navbar user={user} onLogout={logout} />

            {/* Feedback button only for USER role */}
            {user.role === 'USER' && <FeedbackButton />}

            <main className={`app-main ${!isHeaderVisible && user.role !== 'USER' ? 'header-hidden' : ''} ${user.role === 'USER' ? 'user-role' : ''} ${isUserHome && isHeaderVisible ? 'user-home-with-header' : ''}`}>
                <DashboardRoutes />
            </main>
        </div>
    );
}

// Componente principal envuelto en el AuthProvider
function App() {
    return (
        <Router>
            <AuthProvider>
                <FormProvider>
                    <HeaderVisibilityProvider>
                        <FeedbackProvider>
                            <AppContent />
                        </FeedbackProvider>
                    </HeaderVisibilityProvider>
                </FormProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;